import axios from "axios";
import { request } from "@/utils/request";
import store from "@/store";



/**
 * 登录
 * @param {*} phoneNumber
 * @param {*} verCode
 * @returns
 */
// export async function loginNew(data) {
//   const resp = await request({
//     url: `/sys/login`,
//     method: "POST",
//     data
//   });
//   if (resp.code === 200) {
//     console.log(resp);
//     console.log(resp.data);
//   }
//   return resp;
// }


/**
 * 通过医生ID查询科室列表
 * @returns
 */
export async function queryDepartmentListApi(params) {
  const resp = await request({
    url: "/ly/patient/departments/by-professional",
    method: "GET",
	params
  });
  if (resp.code === 200) {
	  return resp.result;
  }else{
	  return null;
  }
}

